import store from '../store';
import { getStoreBuildTodoCount } from '@/api/workflow/index';

export const getStoreBuildTodoNum = async () => {
  const { data = 0 } = await getStoreBuildTodoCount();
  store.commit('setStoreBuildTodoCount', data);
};
